module.exports = __webpack_public_path__ + "static/media/icon-video.13659345.svg";